<template>
  <div class="dashboard-tile">
    <div class="dashboard-tile__title-wrapper">
      <img :src="item.image" :alt="item.name" />
      <p class="dashboard-tile__description" v-html="item.description" />
    </div>
    <CustomLink class="dashboard-tile__button-wrapper" :to="item.buttonLink">
      <Button
        :class="`dashboard-tile__button dashboard-tile__button--${item.name.replace(' ', '-')}`"
      >
        {{ item.buttonText }}
      </Button>
    </CustomLink>
  </div>
</template>

<script>
import { isShape } from '@/common/prop-validators';
import { Button, CustomLink } from '@/components/common';

export default {
  name: 'DashboardTile',
  components: { Button, CustomLink },
  props: {
    item: {
      type: Object,
      validator: isShape({
        image: String,
        name: String,
        description: String,
        buttonText: String,
        buttonLink: String,
      }),
    },
  },
};
</script>

<style lang="scss" scoped>
  .dashboard-tile {
    align-items: center;
    background-color: $white;
    border-radius: 40px;
    box-shadow: 0 2px 83px 0 rgba(34, 48, 87, .07);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-bottom: 24px;
    padding: 20px 20px 40px;

    @include md-up {
      flex-direction: row;
      height: 222px;
      padding: 20px;
    }

    &__title-wrapper {
      align-items: center;
      display: flex;
      flex-direction: column;
      margin-bottom: 40px;
      width: 100%;

      @include md-up {
        flex-direction: row;
        height: 100%;
        margin: 0 50px 0 0;
        width: auto;
      }

      img {
        height: auto;
        margin-bottom: 32px;
        width: 100%;

        @include md-up {
          height: 100%;
          margin: 0 50px 0 0;
          width: auto;
        }
      }
    }

    &__description {
      font-size: 16px;
      line-height: 1.81;
      text-align: center;

      @include md-up {
        text-align: left;
      }
    }

    &__button-wrapper {
      @include lg-up {
        margin-right: 40px;
      }
    }

    &__button {
      background-color: rgba($accent, .1);
      color: $accent;
      flex-shrink: 0;
      height: 60px;
      width: 200px;

      &:hover {
        background-color: darken(rgba($accent, .1), 20%);
        transition: all .6s;
      }

      &--new-estimate {
        background-color: $accent;
        color: $white;

        &:hover {
          background-color: darken($accent, 10%);
          transition: all .6s;
        }
      }
    }
  }
</style>
